import { useMutation } from "@tanstack/react-query";
import {
  syncMatchFromSource,
  SyncFromSourcePayload,
  SyncProvider
} from "@/api/matches/syncFromSource";
import { ImportedEventBundle } from "@/api/matches";

// Mirrors useImportMatchEvents — only injects into form state, no DB
// write yet. The match update mutation is the one that invalidates the
// FullMatches query downstream.
export const useSyncMatchFromSource = () => {
  return useMutation<
    ImportedEventBundle,
    Error,
    { matchId: string; provider: SyncProvider }
  >({
    mutationFn: ({ matchId, provider }) => {
      const payload: SyncFromSourcePayload = { provider };
      return syncMatchFromSource(matchId, payload);
    },
    // This mutation shows its own provider-specific error message at the
    // call site (FullMatchUpdate -> getSyncErrorHint), e.g. "this match
    // isn't on Scoremer, try Sportradar". Defining onError here overrides
    // the global generic "operation failed" toast
    // (defaultOptions.mutations.onError) so the user sees ONE clear toast
    // instead of two. The call-site onError still runs (mutate-level
    // callbacks are additive to the observer-level one).
    onError: () => {}
  });
};
